import React, { Fragment, ReactElement } from 'react';
import { CsvImportResult } from 'api/gen/CsvImportResult';

/**
 * Renders the summary message shown after a CSV import.
 *
 * @param importResult - The import result to summarize.
 * @returns A React fragment with import statistics.
 */
export const renderCsvImortMessage = (importResult: CsvImportResult): ReactElement => {
  const notLoadedAnimals = importResult.numOfProcessedLines - importResult.addedAnimals;
  return <Fragment>
            Počet zvířat v souboru: {importResult.numOfProcessedLines}.<br />
            Počet přidaných zvířat: {importResult.addedAnimals}.<br />
            Počet přeskočených zvířat: {notLoadedAnimals}.
        </Fragment>;
};